<form [formGroup]="ogFg">
  <div formGroupName="adres">

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    [required]=true
                                    class="col-auto custom-input-250"
                                    formControlName="straat"
                                    id="straat"
                                    label="Straatnaam"
    >
    </snelstart-ui-text-form-control>

    <div class="col-auto row">
      <snelstart-ui-number-form-control (change)="saveForm()"
                                        [showAllDecimals]="false"
                                        class="col-auto custom-input-75"
                                        formControlName="huisNummer"
                                        id="huisNummer"
                                        label="Huisnr."
      >
      </snelstart-ui-number-form-control>
      <snelstart-ui-text-form-control (change)="saveForm()"
                                      class="col-auto custom-input-75"
                                      formControlName="huisNummerToevoeging"
                                      id="huisNummerToevoeging"
                                      label="Toev."
      >
      </snelstart-ui-text-form-control>
      <snelstart-ui-text-form-control (change)="saveForm()"
                                      class="col-auto custom-input-125"
                                      formControlName="postcode"
                                      id="postcode"
                                      label="Postcode"
      >
      </snelstart-ui-text-form-control>
    </div>

    <snelstart-ui-text-form-control (change)="saveForm()"
                                    class="me-1 custom-input-250"
                                    formControlName="woonplaats"
                                    id="woonplaats"
                                    label="Plaats"
    >
    </snelstart-ui-text-form-control>

    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsLandcodes"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="landCode"
                                      label="Land"
    >
    </snelstart-ui-select-form-control>
  </div>

  <snelstart-ui-select-form-control (change)="this.saveForm()"
                                    [options]="optionsJaNee"
                                    [required]=true
                                    class="me-1 custom-input-250"
                                    formControlName="onroerendeZaakIsWoning"
                                    label="Betreft het een woning?"
  >
  </snelstart-ui-select-form-control>

  <div *ngIf="this.ogFg.getRawValue().onroerendeZaakIsWoning">

    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="verhuurdeWoningIsDeelVanGroterGeheel"
                                      label="Is de woning afzonderlijk verkoopbaar?"
    >
    </snelstart-ui-select-form-control>


    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="onroerendeZaakIsVerhuurd"
                                      label="Is de woning verhuurd?"
    >
    </snelstart-ui-select-form-control>
  </div>

  <div *ngIf="this.ogFg.getRawValue().onroerendeZaakIsVerhuurd" class="pt-3">
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="waardeJaarlijkseHuur"
                                      id="waardeJaarlijkseHuur"
                                      label="Jaarhuur woning"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>


    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="huurIsMarktconform"
                                      label="Huur marktconform"
    >
    </snelstart-ui-select-form-control>


    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="koperWasHuurderOnroerendeZaak"
                                      label="Is ontvanger de huurder?"
    >
    </snelstart-ui-select-form-control>

    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="true"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="verhuurdOppervlakte"
                                      id="verhuurdOppervlakte"
                                      label="Verhuurd oppervlakte"
    ></snelstart-ui-number-form-control>
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [showAllDecimals]="true"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="totaleOppervlakte"
                                      id="totaleOppervlakte"
                                      label="Totale oppervalkte"
    ></snelstart-ui-number-form-control>
  </div>

  <div *ngIf="this.ogFg.getRawValue().onroerendeZaakIsWoning">

    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="wozwaarde"
                                      id="wozwaarde"
                                      label="WOZ-waarde (zie toelichting)"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>

  </div>
  <div *ngIf="!this.ogFg.getRawValue().onroerendeZaakIsWoning">
    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="waardeEconomischVerkeer"
                                      id="waardeEconomischVerkeer"
                                      label="Waarde econ. verkeer"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
  <div *ngIf="this.ogFg.getRawValue().onroerendeZaakIsWoning">

    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="me-1 custom-input-250"
                                      formControlName="waardeErfpachtcanon"
                                      id="waardeErfpachtcanon"
                                      label="Bedrag jaarlijkste erfpachtcanon"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>

  </div>
  <div
    *ngIf="this.ogFg.getRawValue().waardeErfpachtcanon !== null && this.ogFg.getRawValue().waardeErfpachtcanon > 0">

    <snelstart-ui-date-form-control (change)="saveForm()"
                                    class="me-1 custom-input-250"
                                    formControlName="eindDatumErfpacht"
                                    label="Einddatum erfpacht"
    >
    </snelstart-ui-date-form-control>

  </div>
  <snelstart-ui-number-form-control (change)="saveForm()"
                                    [showAllDecimals]="true"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="tellerOvergedragenAandeel"
                                    id="tellerOvergedragenAandeel"
                                    label="Teller overgedr. aandeel"
  ></snelstart-ui-number-form-control>
  <snelstart-ui-number-form-control (change)="saveForm()"
                                    [showAllDecimals]="true"
                                    align="right"
                                    class="custom-input-250"
                                    formControlName="noemerOvergedragenAandeel"
                                    id="noemerOvergedragenAandeel"
                                    label="Noemer overgedr. aandeel"
  ></snelstart-ui-number-form-control>

  <div class="pt-1">
    <snelstart-ui-select-form-control (change)="this.saveForm()"
                                      [options]="optionsJaNee"
                                      [required]=true
                                      class="me-1 custom-input-250"
                                      formControlName="koopsomLagerDanMarktwaarde"
                                      label="Is er een koopsom betaald?"
    >
    </snelstart-ui-select-form-control>
  </div>
  <div *ngIf="this.ogFg.getRawValue().koopsomLagerDanMarktwaarde">

    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="koopsom"
                                      id="koopsom"
                                      label="Bedrag van de koopsom"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>

    <snelstart-ui-number-form-control (change)="saveForm()"
                                      [minValue]="1"
                                      [showAllDecimals]="false"
                                      align="right"
                                      class="custom-input-250"
                                      formControlName="kwijtgescholdenKoopsom"
                                      id="kwijtgescholdenKoopsom"
                                      label="Bedrag evt. kwijtgescholden koopsom"
                                      prefix="€"
    >
    </snelstart-ui-number-form-control>
  </div>
</form>
